<template>
  <div>
    <div class="row">
      <div class="col-md-3">
        <Notifications />
        <div class="card mb-3">
          <div class="card-body">
            <h5 class="card-title">Bližnjice</h5>
            <p class="card-text">
              <button class="btn btn-link" type="button" @click="$router.push({ name: 'ServiceOrdersMap' })">
                Zemljevid 🚩 aktivnih SDN
              </button>

              <button class="btn btn-link" type="button" @click="$router.push({ name: 'Calendar' })">
                Koledar SDN
              </button>
            </p>
          </div>
        </div>
        <InternalOrdersCard
          class="card mb-3"
          title="Interni nalogi"
          subTitle="Accepted, zame"
          :ownerID="worker.id.value"
          statuses="Accepted"
          v-if="worker.id.value"
        />
        <UniversalCard
          class="card mb-3"
          title="Delavci s prometom"
          subTitle="tekoči in prejšnji mesec"
          url="Analytics/WorkersWithRevenue"
        />
        <DevicesListCard class="card mb-3" />
      </div>
      <div class="col">
        <WorkersCard class="card mb-3" :showVehicle="true" />
        <DevicesCard class="card mb-3" />
        <div class="row">
          <div class="col">
            <UniversalCard
              class="card mb-3"
              title="SDN ni končan"
              subTitle="48h po zaključeni medskladiščnici"
              url="Analytics/NotComplete48hAfterCompleteTransfer"
            />
          </div>
          <div class="col">
            <UniversalCard
              class="card mb-3"
              title="Nepotrjene medskaldiščnice"
              subTitle="po začetku dela"
              url="Analytics/TransferNotCompleted"
            />
          </div>
          <div class="col">
            <UniversalCard
              class="card mb-3"
              title="Nepotrjene poštne medskaldiščnice"
              subTitle="po pošiljanju"
              url="Analytics/TransitTransferNotCompletedIn48h"
            />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <UniversalCard
              class="card mb-3"
              title="SDN z naskladjem v komisionih"
              subTitle="Completed, Finalized"
              url="Analytics/ServiceOrderCommissionDiscrepancy"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { useWorker } from "../composition-api/useWorker"
import InternalOrdersCard from "../components/InternalOrdersCard.vue"
import WorkersCard from "../components/WorkersCard.vue"
import Notifications from "../components/Notifications.vue"
import UniversalCard from "../components/UniversalCard.vue"
import DevicesListCard from "../components/DevicesListCard.vue"

defineOptions({ name: "HomeAdmin" })

const { worker } = useWorker()
</script>
